/* Better Left Alone — theme JS */
(function () {
  'use strict';

  /* ── Scroll reveals ── */
  var obs = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv, .ledger-entry').forEach(function (el) { obs.observe(el); });

  /* ── Mobile nav ── */
  var burger = document.querySelector('.tb-menu');
  var mnav = document.querySelector('.mobile-nav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      mnav.classList.toggle('open');
      document.body.style.overflow = mnav.classList.contains('open') ? 'hidden' : '';
    });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mnav.classList.remove('open'); document.body.style.overflow = ''; });
    });
  }

  /* ── Cart helpers ── */
  function refreshCartCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var c = document.querySelector('[data-cart-count]');
      if (c) c.textContent = cart.item_count;
      return cart;
    });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  /* ── Catalog filter pills ── */
  var pills = document.querySelectorAll('.cat-pill');
  if (pills.length) {
    var groups = document.querySelectorAll('.cat-group');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        groups.forEach(function (g) {
          var show = g.dataset.group === pill.dataset.filter;
          g.classList.toggle('hidden', !show);
          if (show) {
            g.querySelectorAll('.cat-row').forEach(function (r) {
              r.style.animation = 'none';
              void r.offsetWidth;
              r.style.animation = '';
            });
          }
        });
      });
    });
  }

  /* ── Catalog quick-add ── */
  var openPop = null;
  function closePop() { if (openPop) { openPop.remove(); openPop = null; } }
  document.addEventListener('click', function (e) {
    if (openPop && !openPop.contains(e.target) && !e.target.closest('[data-quickadd]')) closePop();
  });
  document.querySelectorAll('[data-quickadd]').forEach(function (btn) {
    function activate(e) {
      e.preventDefault();
      e.stopPropagation();
      closePop();
      var raw = (btn.dataset.variants || '').split('||').filter(Boolean);
      var variants = raw.map(function (s) {
        var parts = s.split('::');
        return { id: parts[0], title: parts.slice(1).join('::') };
      });
      if (!variants.length) return;
      function flash(text) {
        var orig = '+ Bag';
        btn.textContent = text;
        btn.classList.add('added');
        refreshCartCount();
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('added'); }, 1600);
      }
      if (variants.length === 1) {
        addToCart(variants[0].id).then(function () { flash('Added ✓'); }).catch(function () { flash('Error'); });
        return;
      }
      var pop = document.createElement('div');
      pop.className = 'qa-pop';
      pop.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); });
      var label = document.createElement('div');
      label.className = 'qa-pop-label';
      label.textContent = 'Pick one';
      pop.appendChild(label);
      variants.forEach(function (v) {
        var b = document.createElement('span');
        b.className = 'qa-opt';
        b.setAttribute('role', 'button');
        b.setAttribute('tabindex', '0');
        b.textContent = v.title;
        function pick(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          addToCart(v.id).then(function () { closePop(); flash('Added ✓'); }).catch(function () { closePop(); flash('Error'); });
        }
        b.addEventListener('click', pick);
        b.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') pick(ev); });
        pop.appendChild(b);
      });
      btn.closest('.cat-row').appendChild(pop);
      openPop = pop;
    }
    btn.addEventListener('click', activate);
    btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') activate(e); });
  });

  /* ── Catalog hover preview ── */
  var prev = document.getElementById('catPreview');
  if (prev && window.matchMedia('(hover:hover)').matches) {
    var pimg = prev.querySelector('img');
    var px = 0, py = 0, ptx = 0, pty = 0;
    document.querySelectorAll('.cat-row[data-img]').forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        if (row.dataset.img) { pimg.src = row.dataset.img; prev.classList.add('on'); }
      });
      row.addEventListener('mouseleave', function () { prev.classList.remove('on'); });
    });
    document.addEventListener('mousemove', function (e) { ptx = e.clientX + 24; pty = e.clientY - 140; });
    (function lerp() {
      px += (ptx - px) * 0.1; py += (pty - py) * 0.1;
      prev.style.left = px + 'px'; prev.style.top = py + 'px';
      requestAnimationFrame(lerp);
    })();
  }

  /* ── Drag scroll for plates ── */
  document.querySelectorAll('.plates-scroll').forEach(function (ps) {
    var down = false, sx = 0, sl = 0, moved = false;
    ps.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = ps.scrollLeft; });
    ['mouseup', 'mouseleave'].forEach(function (ev) { ps.addEventListener(ev, function () { down = false; }); });
    ps.addEventListener('mousemove', function (e) {
      if (!down) return;
      e.preventDefault();
      if (Math.abs(e.pageX - sx) > 4) moved = true;
      ps.scrollLeft = sl - (e.pageX - sx) * 1.3;
    });
    ps.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
  });

  /* ── Gyro tilt on hero band (mobile) ── */
  if (window.DeviceOrientationEvent && window.matchMedia('(max-width:860px)').matches) {
    var gimgs = document.querySelectorAll('.hpb-img');
    window.addEventListener('deviceorientation', function (e) {
      var g = (e.gamma || 0) / 45, b = ((e.beta || 45) - 45) / 45;
      gimgs.forEach(function (im) {
        im.style.transform = 'translate(' + (g * 8) + 'px,' + (b * 6) + 'px) scale(1.06)';
      });
    }, { passive: true });
  }

  /* ── Drop countdown ── */
  document.querySelectorAll('[data-countdown]').forEach(function (cd) {
    var raw = cd.dataset.countdown;
    var target = new Date(raw.replace(' ', 'T'));
    if (isNaN(target)) return;
    var dEl = cd.querySelector('[data-cd-d]'), hEl = cd.querySelector('[data-cd-h]'),
        mEl = cd.querySelector('[data-cd-m]'), sEl = cd.querySelector('[data-cd-s]'),
        disp = cd.querySelector('[data-cd-display]'), done = cd.querySelector('[data-cd-done]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        disp.style.display = 'none';
        done.classList.remove('hidden');
        clearInterval(iv);
        return;
      }
      dEl.textContent = pad(Math.floor(diff / 864e5));
      hEl.textContent = pad(Math.floor(diff / 36e5) % 24);
      mEl.textContent = pad(Math.floor(diff / 6e4) % 60);
      sEl.textContent = pad(Math.floor(diff / 1e3) % 60);
    }
    tick();
    var iv = setInterval(tick, 1000);
  });

  /* ── Password page toggle ── */
  var pwT = document.querySelector('[data-pw-toggle]');
  if (pwT) {
    pwT.addEventListener('click', function () {
      document.querySelector('[data-pw-entry]').classList.toggle('hidden');
    });
  }

  /* ════════════════════════════════════════════
     PRODUCT PAGE
     Carousel gallery + Printify color grouping:
     images grouped by COLOR via alt-text match;
     arrows cycle only the visible (matching) set.
     ════════════════════════════════════════════ */
  var pp = document.querySelector('[data-product-json]');
  if (pp) {
    var product = JSON.parse(pp.textContent);
    var root = document.querySelector('.product-page');
    var mainWrap = root.querySelector('.pp-main-img');
    var mainImg = mainWrap.querySelector('img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pp-thumb'));
    var atcBtn = root.querySelector('.pp-atc');
    var priceEl = root.querySelector('.pp-price');
    var variantInput = root.querySelector('input[name="id"]');
    var optionBlocks = Array.prototype.slice.call(root.querySelectorAll('.pp-option'));
    var counterIdx = mainWrap.querySelector('[data-counter-idx]');
    var counterTotal = mainWrap.querySelector('[data-counter-total]');
    var notifyBox = document.querySelector('[data-notify]');
    var notifyVariant = document.querySelector('[data-notify-variant]');
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var stickyBtn = document.querySelector('[data-sticky-btn]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var colorIndex = -1;

    product.options.forEach(function (name, i) {
      if (/colou?r/i.test(name)) colorIndex = i;
    });

    var selected = optionBlocks.map(function (block) {
      var active = block.querySelector('.pp-swatch.active');
      return active ? active.dataset.value : null;
    });

    /* ── Carousel state ── */
    var visible = thumbs.slice();
    var current = 0;

    function pad2(n) { return String(n).padStart(2, '0'); }

    function show(i) {
      if (!visible.length) return;
      current = ((i % visible.length) + visible.length) % visible.length;
      var t = visible[current];
      mainImg.style.opacity = '0';
      var swap = new Image();
      swap.onload = function () {
        mainImg.src = t.dataset.full;
        mainImg.alt = t.dataset.alt || product.title;
        mainImg.style.opacity = '1';
      };
      swap.src = t.dataset.full;
      mainWrap.classList.remove('zoomed');
      if (counterIdx) counterIdx.textContent = pad2(current + 1);
      if (counterTotal) counterTotal.textContent = pad2(visible.length);
    }

    function rebuildVisible(color) {
      if (colorIndex === -1 || !color) {
        visible = thumbs.slice();
      } else {
        var norm = color.toLowerCase().trim();
        visible = thumbs.filter(function (t) {
          return (t.dataset.alt || '').toLowerCase().indexOf(norm) !== -1;
        });
        /* Printify fallback: nothing matched the color → show everything */
        if (!visible.length) visible = thumbs.slice();
      }
      show(0);
    }

    var prevBtn = mainWrap.querySelector('.pp-prev');
    var nextBtn = mainWrap.querySelector('.pp-next');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });

    /* swipe */
    var touchX = null;
    mainWrap.addEventListener('touchstart', function (e) {
      if (mainWrap.classList.contains('zoomed')) return;
      touchX = e.touches[0].clientX;
    }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      if (touchX === null || mainWrap.classList.contains('zoomed')) { touchX = null; return; }
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
      touchX = null;
    }, { passive: true });

    /* zoom — click/tap toggles, origin follows point */
    mainWrap.addEventListener('click', function (e) {
      if (e.target.closest('.pp-nav')) return;
      var r = mainWrap.getBoundingClientRect();
      var ox = ((e.clientX - r.left) / r.width) * 100;
      var oy = ((e.clientY - r.top) / r.height) * 100;
      mainImg.style.transformOrigin = ox + '% ' + oy + '%';
      mainWrap.classList.toggle('zoomed');
    });
    mainWrap.addEventListener('mousemove', function (e) {
      if (!mainWrap.classList.contains('zoomed')) return;
      var r = mainWrap.getBoundingClientRect();
      var ox = ((e.clientX - r.left) / r.width) * 100;
      var oy = ((e.clientY - r.top) / r.height) * 100;
      mainImg.style.transformOrigin = ox + '% ' + oy + '%';
    });

    /* ── Variant logic ── */
    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
    function currentVariant() {
      return product.variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      }) || null;
    }

    function updateUI() {
      var v = currentVariant();
      optionBlocks.forEach(function (block, i) {
        var label = block.querySelector('.pp-option-label strong');
        if (label) label.textContent = selected[i] || '—';
        block.querySelectorAll('.pp-swatch').forEach(function (sw) {
          var test = selected.slice();
          test[i] = sw.dataset.value;
          var exists = product.variants.some(function (vr) {
            return vr.available && test.every(function (val, j) { return val === null || vr.options[j] === val; });
          });
          sw.classList.toggle('unavailable', !exists);
        });
      });
      var soldOut = false;
      if (v) {
        variantInput.value = v.id;
        var html = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
        soldOut = !v.available;
        atcBtn.disabled = soldOut;
        atcBtn.textContent = v.available ? atcBtn.dataset.addText : atcBtn.dataset.soldText;
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (stickyBtn) {
          stickyBtn.disabled = soldOut;
          stickyBtn.textContent = v.available ? atcBtn.dataset.addText : atcBtn.dataset.soldText;
        }
        if (notifyVariant) notifyVariant.value = product.title + ' — ' + v.title;
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = atcBtn.dataset.unavailableText;
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = atcBtn.dataset.unavailableText; }
      }
      if (notifyBox) notifyBox.classList.toggle('hidden', !soldOut);
    }

    optionBlocks.forEach(function (block, i) {
      block.querySelectorAll('.pp-swatch').forEach(function (sw) {
        sw.addEventListener('click', function () {
          block.querySelectorAll('.pp-swatch').forEach(function (s) { s.classList.remove('active'); });
          sw.classList.add('active');
          selected[i] = sw.dataset.value;
          if (i === colorIndex) rebuildVisible(sw.dataset.value);
          updateUI();
        });
      });
    });

    /* ── AJAX add to cart (shared by main + sticky) ── */
    function doAdd(btn) {
      btn.textContent = atcBtn.dataset.addingText;
      addToCart(variantInput.value)
        .then(refreshCartCount)
        .then(function () {
          btn.textContent = atcBtn.dataset.addedText;
          setTimeout(function () { btn.textContent = atcBtn.dataset.addText; }, 1800);
        })
        .catch(function () {
          btn.textContent = atcBtn.dataset.errorText;
          setTimeout(function () { btn.textContent = atcBtn.dataset.addText; }, 1800);
        });
    }
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(atcBtn); });
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () { doAdd(stickyBtn); });

    /* ── Sticky bar visibility: show once main ATC scrolls out of view ── */
    if (stickyBar && atcBtn) {
      var stickyObs = new IntersectionObserver(function (es) {
        stickyBar.classList.toggle('show', !es[0].isIntersecting);
      }, { threshold: 0 });
      stickyObs.observe(atcBtn);
    }

    /* init */
    rebuildVisible(colorIndex !== -1 ? selected[colorIndex] : null);
    updateUI();
  }


  /* ── Easter egg: 7 taps on the horseshoe spills the luck ── */
  var luck = document.querySelector('[data-luck]');
  if (luck) {
    var taps = 0, tapTimer = null, spilled = false;
    luck.style.cursor = 'pointer';
    luck.addEventListener('click', function () {
      if (spilled) return;
      taps++;
      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () { taps = 0; }, 1500);
      luck.classList.add('luck-nudge');
      setTimeout(function () { luck.classList.remove('luck-nudge'); }, 220);
      if (taps >= 7) {
        spilled = true;
        luck.classList.add('luck-flipped');
        var reveal = document.querySelector('[data-luck-reveal]');
        var code = luck.dataset.luckCode || 'LUCKY777';
        reveal.querySelector('.luck-msg').textContent = luck.dataset.luckText || 'You spilled the luck — 7% off';
        var codeEl = reveal.querySelector('.luck-code');
        codeEl.textContent = code;
        function copyCode(e) {
          e.preventDefault();
          if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(function () {
              codeEl.textContent = 'Copied ✓';
              setTimeout(function () { codeEl.textContent = code; }, 1400);
            });
          }
        }
        codeEl.addEventListener('click', copyCode);
        codeEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') copyCode(e); });
        setTimeout(function () { reveal.hidden = false; }, 450);
      }
    });
  }

  /* ── Ticker: pause on hover/touch ── */
  document.querySelectorAll('.ticker-track').forEach(function (t) {
    t.addEventListener('mouseenter', function () { t.style.animationPlayState = 'paused'; });
    t.addEventListener('mouseleave', function () { t.style.animationPlayState = 'running'; });
  });

  /* ── Cart page quantity / remove ── */
  document.querySelectorAll('.cart-line').forEach(function (line) {
    var key = line.dataset.key;
    var input = line.querySelector('.cart-qty input');
    function change(qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    }
    line.querySelectorAll('.cart-qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = parseInt(input.value, 10) + (btn.dataset.dir === 'up' ? 1 : -1);
        if (q < 0) q = 0;
        change(q);
      });
    });
    var rm = line.querySelector('.cart-remove');
    if (rm) rm.addEventListener('click', function () { change(0); });
  });
})();
